import type { PottingInfo } from '../../types/careExpanded';

interface PottingSectionProps {
  potting: PottingInfo;
}

export function PottingSection({ potting }: PottingSectionProps) {
  return (
    <div className="space-y-4">
      {/* Root preference and pot sizing */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <dt className="text-xs font-medium uppercase tracking-wide text-gray-500">
            Root Preference
          </dt>
          <dd className="mt-1 text-sm text-editorial-black">{potting.rootPreference}</dd>
        </div>
        <div>
          <dt className="text-xs font-medium uppercase tracking-wide text-gray-500">
            Pot Sizing
          </dt>
          <dd className="mt-1 text-sm text-editorial-black">{potting.potSizing}</dd>
        </div>
      </div>

      {/* When to repot */}
      <div className="p-3 rounded-lg bg-amber-500/5 border border-amber-500/10">
        <dt className="text-xs font-medium uppercase tracking-wide text-amber-600">
          When to Repot
        </dt>
        <dd className="mt-1 text-sm text-editorial-black">{potting.repotCriteria}</dd>
      </div>

      {/* Pot shape and drainage */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {potting.potShape && (
          <div>
            <dt className="text-xs font-medium uppercase tracking-wide text-gray-500">
              Pot Shape
            </dt>
            <dd className="mt-1 text-sm text-editorial-black">{potting.potShape}</dd>
          </div>
        )}
        <div>
          <dt className="text-xs font-medium uppercase tracking-wide text-gray-500">
            Drainage
          </dt>
          <dd className="mt-1 text-sm text-editorial-black">{potting.drainage}</dd>
        </div>
      </div>

      {/* Additional notes */}
      {potting.notes && (
        <div>
          <dt className="text-xs font-medium uppercase tracking-wide text-gray-500">
            Tips
          </dt>
          <dd className="mt-1 text-sm text-editorial-black">{potting.notes}</dd>
        </div>
      )}
    </div>
  );
}
